import route from "@/components/router/Router";
import allEnterprise from "./all_enterprise/index";
import focusEnterprise from "./focus_enterprise/index";
import recycledEnterprise from "./recycled_enterprise/index";
import inputEnterprise from "./input_enterprise/index";
import reportEnterprise from "./report_enterprise/index";
import integralEnterprise from "./integral_enterprise/index";
import accountEnterprise from "./account_enterprise/index";


export default {
    path : "enterprise",
    name : "enterprise",
    meta : {
       title : "企业"
    },
    redirect: {
        name : "enterprise-all"
    },
    component : route,
    children : [
        allEnterprise,
        focusEnterprise,
        integralEnterprise,
        recycledEnterprise,
        reportEnterprise,
        accountEnterprise,
        ...inputEnterprise
    ],
}



// WEBPACK FOOTER //
// ./src/router/enterprise/indexRouter.js